export const AddressType = {
  ORDER: 1,
  SAVED: 2,
} as const;

export type AddressTypeValue = (typeof AddressType)[keyof typeof AddressType];

export interface AddressData {
  title: string;
  phoneNumber: string;
  address: string;
  companyName?: string;
  city?: string;
  district?: string;
  neighborhood?: string;
  orderNote?: string;
}

export interface UserAddress {
  id: number;
  addressType: AddressTypeValue;
  orderId?: number | null;
  label?: string | null;
  addressData: AddressData;
  createdAt?: string;
  updatedAt?: string;
}

export interface UserAddressesResponse {
  addresses: UserAddress[];
}
